import moment from 'moment';

function convertDatetimeToLocal(datetime) {
  const utcDate = moment.utc(datetime, 'DD-MM-YYYY HH:mm:ss');
  const localDate = utcDate.local().format('DD.MM.YYYY HH:mm:ss');

  return localDate;
}

export default {
    convertDatetimeToLocal,
};
